import script from "./Register.vue?vue&type=script&setup=true&lang=ts"
export * from "./Register.vue?vue&type=script&setup=true&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=910102ee&lang=scss"

const __exports__ = script;

export default __exports__